import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/auth/protected-route";
import { MainLayout } from "@/components/layout/main-layout";

export const Route = createFileRoute("/_authenticated")({
  component: () => (
    <MainLayout>
      <ProtectedRoute />
    </MainLayout>
  ),
});

